import React from "react";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { useLang } from "../i18n/LanguageContext";
import { SITE } from "../i18n/translations";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "This Privacy Policy explains how TarapithTantrik.com handles information you choose to share.",
      "When you start a guided enquiry, we may collect the details you provide (such as your name, location, phone and a description of your concern) in order to respond to you and provide guidance. These details are used only for communicating with you and are not sold to third parties.",
      "Continuing an enquiry on WhatsApp is subject to WhatsApp's own privacy terms. You may request that we delete your enquiry details at any time by contacting us.",
      "This site may use basic, privacy-respecting analytics to understand general usage. We do not knowingly collect data from children.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "By using TarapithTantrik.com you agree to these terms.",
      "The content on this website is provided for educational and devotional purposes. Spiritual and traditional practices are offered respectfully; participation is voluntary and based on personal faith.",
      "No specific worldly outcome is promised or guaranteed. Fees, timings and arrangements for any puja, havan or consultation are agreed directly between you and the practitioner.",
      "All content is the intellectual property of TarapithTantrik.com unless otherwise stated and may not be reproduced without permission.",
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    body: [
      "TarapithTantrik.com presents information about Tarapith, Maa Tara and Tantra with care to distinguish verified history, traditional belief, local folklore and spiritual interpretation.",
      "Spiritual and traditional religious practices offered here do not replace qualified medical, mental-health, legal or financial advice. For health, fertility, mental-health or legal/financial matters, please consult appropriate licensed professionals.",
      "No ritual, puja or consultation is claimed to certainly control, harm, punish or destroy another person, nor to guarantee any specific result. Guidance is intended to help you understand available spiritual and devotional options.",
      "Individual experiences vary. Participation is a matter of personal faith and choice.",
    ],
  },
  editorial: {
    title: "Editorial Policy",
    body: [
      "Content on TarapithTantrik.com is created and reviewed with attention to factual accuracy and respectful presentation of tradition.",
      "We clearly distinguish verified history from traditional belief and folklore, and we cite general sources where appropriate.",
      "Pages carry a last-updated date and are authored under the responsibility of Shivam Chatterjee. Corrections and improvements are welcomed.",
      "We prioritise quality and accuracy over publishing large volumes of thin content.",
    ],
  },
};

export default function Legal({ kind = "privacy" }) {
  const { t } = useLang();
  const data = CONTENT[kind] || CONTENT.privacy;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <Seo title={data.title} description={`${data.title} for ${SITE.name}.`} path={`/${kind}`} />
      <Breadcrumbs items={[{ label: data.title }]} />
      <h1 className="font-serif text-4xl font-bold text-tara-ink mb-2">{data.title}</h1>
      <p className="text-xs text-tara-muted mb-8">{t("last_updated")}: 2026-06-01</p>
      <div className="prose-tara">
        {data.body.map((p, i) => <p key={i}>{p}</p>)}
      </div>
    </div>
  );
}
